var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5859 20.8854C12.443 20.8854 12.3287 20.8283 12.2144 20.7426L6.98594 15.4855C6.78594 15.2855 6.78594 14.9712 6.98594 14.7427C7.18593 14.5427 7.50021 14.5427 7.72878 14.7427L12.1002 19.114V0.514279C12.1002 0.228568 12.3287 0 12.6144 0C12.9001 0 13.1287 0.228568 13.1287 0.514279V19.0569L17.5001 14.7712C17.7001 14.5712 18.0144 14.5712 18.2144 14.7712C18.4144 14.9712 18.4144 15.2855 18.2144 15.4855L12.9573 20.7426C12.8716 20.8283 12.7287 20.8854 12.5859 20.8854Z",
    fill: "#E83A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6141 28.0006C5.9285 28.0006 0.5 22.5721 0.5 15.8865C0.5 10.6008 3.87138 5.97234 8.89989 4.37236C9.15703 4.28665 9.47131 4.4295 9.55702 4.71521C9.64273 4.97235 9.49988 5.28663 9.21417 5.37235C4.61423 6.85804 1.52856 11.0866 1.52856 15.9151C1.55713 22.0007 6.49992 26.9721 12.6141 26.9721C18.7283 26.9721 23.6711 22.0007 23.6711 15.9151C23.6711 11.0866 20.5854 6.85804 15.9855 5.37235C15.7284 5.28663 15.5569 5.00092 15.6427 4.71521C15.7284 4.45807 16.0141 4.28665 16.2998 4.37236C21.3283 5.97234 24.6997 10.6294 24.6997 15.8865C24.7282 22.5721 19.2997 28.0006 12.6141 28.0006Z",
    fill: "#E83A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6efc2d1295d53ebe6f412de25d2754af.svg";
export { ForwardRef as ReactComponent };